export const numberOfLines = {
  inserted: function (el, binding) {
    let maxlines = binding.value;
    let lineheight = parseFloat(getComputedStyle(el).lineHeight);
    let paddingtop = parseFloat(getComputedStyle(el).paddingTop);
    let lines = (el.clientHeight) / lineheight;
    let maxheight = (lineheight * maxlines) + paddingtop;

    if (lines > maxlines) {
      el.classList.add('...');
      el.style.maxHeight = maxheight + 'px';
    }
  },
}
